import { useState } from "react";
import { Plus, Tag, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { errMsg } from "./kpiFormat";

export const ProductCategories = ({ services, canEdit, onChange }) => {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const cats = services.filter((s) => s.kind === "category" && s.active !== false);

  const add = async () => {
    setBusy(true);
    try {
      const r = await api.post("/kpi/services", { name: name.trim() });
      toast.success(`Category “${r.data.name}” added`);
      setName("");
      onChange();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const archive = async (c) => {
    try {
      await api.put(`/kpi/services/${c.id}`, { active: false });
      toast.success(`Category “${c.name}” archived`);
      onChange();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-md border border-zinc-200 bg-zinc-50/60 px-3 py-2.5" data-testid="kpi-product-categories">
      <span className="text-2xs font-semibold uppercase tracking-[0.18em] text-zinc-500 mr-1">Product categories</span>
      {cats.map((c) => (
        <span key={c.id} className="inline-flex items-center gap-1 rounded-full border border-zinc-300 bg-white px-2.5 py-0.5 text-xs"
          data-testid={`kpi-category-chip-${c.id}`}>
          <Tag className="h-3 w-3 text-zinc-400" />{c.name}
          {canEdit && !c.builtin && (
            <button type="button" onClick={() => archive(c)} className="ml-0.5 text-zinc-400 hover:text-red-600"
              aria-label={`Archive ${c.name}`} data-testid={`kpi-category-archive-${c.id}`}><X className="h-3 w-3" /></button>
          )}
        </span>
      ))}
      {canEdit && (
        <form className="flex items-center gap-1.5 ml-auto" onSubmit={(e) => { e.preventDefault(); add(); }}>
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="New category, e.g. Gift vouchers"
            className="h-8 w-56 bg-white text-xs" maxLength={40} data-testid="kpi-category-name-input" />
          <Button type="submit" size="sm" variant="outline" disabled={busy || name.trim().length < 2} data-testid="kpi-category-add-btn">
            <Plus className="h-4 w-4 mr-1" />Add
          </Button>
        </form>
      )}
    </div>
  );
};
